import { logWrapper } from '../../utils';

export default {
  shareRevisionService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'userModel',
    'roleModel',
    'revService',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      User,
      Role,
      Revision
    ) {
      'use strict';

      function handleError(err, status) {
        //falhou
        if (status === 404) {
          var error = {
            error: $filter('translate')('ERROR'),
            error_description: $filter('translate')('REVISION NOT FOUND'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function loadByRevision(revisions) {
        var deferred = $q.defer();

        var revisionsId = revisions.map(function (r) {
          return r.id;
        });

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}shared/sharedbyrevisions`,
            revisionsId,
            {
              ignoreLoadingBar: true,
            }
          )
          .then((result) => {
            var data = result.data;
            var viewModels = data.map((r) => {
              return {
                idFolder: r.RevisionRoles[0].Revision.IdFolder,
                reciever: new User(r.SharedWith),
                sender: new User(r.SharedBy),
                revisionRoles: r.RevisionRoles.map((rr) => {
                  return {
                    revs: new Revision(rr.Revision),
                    roles: rr.Roles.map((role) => new Role(role)),
                  };
                }),
                sharedDate: r.SharedDate,
              };
            });

            deferred.resolve(viewModels);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function removeShared(revisionsShared) {
        var deferred = $q.defer();
        if (!Array.isArray(revisionsShared) || revisionsShared.length === 0) {
          deferred.resolve(true);
        } else {
          $http
            .post(
              webApiSettings.apiServiceBaseUri + 'shared/removeShared',
              revisionsShared,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(() => {
              deferred.resolve(true);
            })
            .catch((err) => {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            });
        }
        return deferred.promise;
      }

      function save(revisionsShared) {
        var deferred = $q.defer();
        if (
          revisionsShared &&
          revisionsShared.shares &&
          Object.keys(revisionsShared.shares).length <= 0
        ) {
          deferred.resolve(true);
        } else {
          $http
            .post(
              webApiSettings.apiServiceBaseUri + 'shared',
              revisionsShared,
              {
                ignoreLoadingBar: true,
              }
            )
            .then(() => {
              deferred.resolve(true);
            })
            .catch((err) => {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            });
        }
        return deferred.promise;
      }

      function run() {
        try {
          var shareRevisionFactory = {};

          shareRevisionFactory.loadByRevision = logWrapper(
            loadByRevision,
            runtimeConstant.isDebugServicesInternals
          );

          shareRevisionFactory.removeShared = logWrapper(
            removeShared,
            runtimeConstant.isDebugServicesInternals
          );

          shareRevisionFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );

          return shareRevisionFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
